// extracted by mini-css-extract-plugin
export default {"label":"app-assets-javascripts-components-betaLabel-betaLabel__label--O2k6h","large":"app-assets-javascripts-components-betaLabel-betaLabel__large--F0rN_"};